import React, { useState } from 'react';
import { tokens as defaultTokens } from '../tokens';

/* Small SVG glyphs */
function PhoneGlyph({ size = 14, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" style={{ display: 'block' }}>
      <path d="M4 5.5C4 4.7 4.7 4 5.5 4H8l2 5-2.5 1.5a11 11 0 005 5L14 13l5 2v2.5c0 .8-.7 1.5-1.5 1.5A13.5 13.5 0 014 5.5z"
        stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
    </svg>
  );
}

function MessageGlyph({ size = 14, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" style={{ display: 'block' }}>
      <path d="M4 5h16v11H8l-4 3V5z"
        stroke={color} strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round"/>
    </svg>
  );
}

export default function CrisisRail({ tokens = defaultTokens, items }) {
  const [idx, setIdx] = useState(0);
  const item = items[idx];

  return (
    <section style={{
      border: `1px solid ${tokens.accent}55`,
      background: tokens.accentGlow,
      position: 'relative',
    }}>
      {/* header strip */}
      <div style={{
        display: 'flex', alignItems: 'center', gap: 10,
        padding: '10px 14px',
        borderBottom: `1px solid ${tokens.accent}33`,
      }}>
        <span style={{
          width: 6, height: 6, borderRadius: '50%', background: tokens.accent,
          boxShadow: `0 0 8px ${tokens.accent}`,
          animation: 'gl-breathe 2.5s ease-in-out infinite',
        }} />
        <span style={{
          fontFamily: tokens.fontBody,
          fontSize: 11, letterSpacing: '0.18em', fontWeight: 500,
          textTransform: 'uppercase', color: tokens.accent,
        }}>If you need someone right now</span>
        <span style={{ flex: 1 }} />
        <span style={{
          fontFamily: tokens.fontBody, fontSize: 11,
          color: tokens.textLow, letterSpacing: '0.05em',
        }}>{idx + 1} / {items.length}</span>
      </div>

      {/* body */}
      <div style={{ padding: '18px 16px 16px' }}>
        <div style={{
          fontFamily: tokens.fontDisplay,
          fontSize: 22, fontWeight: tokens.displayWeight,
          color: tokens.textHi,
          letterSpacing: tokens.displayTracking,
          lineHeight: 1.25,
        }}>{item.name}</div>
        <div style={{
          marginTop: 8,
          fontFamily: tokens.fontBody, fontSize: 13.5,
          color: tokens.textMid, lineHeight: 1.55,
        }}>{item.line}</div>
        <div style={{ marginTop: 14, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <a href={item.action} style={{
            textDecoration: 'none',
            display: 'inline-flex', alignItems: 'center', gap: 8,
            padding: '10px 16px',
            background: tokens.accent,
            color: tokens.ground,
            fontFamily: tokens.fontBody, fontSize: 13.5, fontWeight: 500,
            letterSpacing: '0.02em',
          }}>
            {item.action.startsWith('tel:') ? <PhoneGlyph /> : item.action.startsWith('sms:') ? <MessageGlyph /> : null}
            {item.actionLabel}
          </a>
          {item.alt && (
            <a href={item.alt} style={{
              textDecoration: 'none',
              display: 'inline-flex', alignItems: 'center', gap: 8,
              padding: '10px 16px',
              border: `1px solid ${tokens.accent}77`,
              color: tokens.accent,
              fontFamily: tokens.fontBody, fontSize: 13.5, fontWeight: 400,
            }}>
              {item.alt.startsWith('tel:') ? <PhoneGlyph /> : item.alt.startsWith('sms:') ? <MessageGlyph /> : null}
              {item.altLabel}
            </a>
          )}
        </div>
      </div>

      {/* carousel controls */}
      <div style={{
        display: 'flex', alignItems: 'center', gap: 4,
        padding: '10px 12px 12px',
        borderTop: `1px solid ${tokens.accent}22`,
      }}>
        <button className="gl-btn-bare" onClick={() => setIdx((idx - 1 + items.length) % items.length)}
          style={{ color: tokens.textMid, fontFamily: tokens.fontBody, fontSize: 12, padding: '4px 10px' }}>&#8592; Prev</button>
        <div style={{ flex: 1, display: 'flex', justifyContent: 'center', gap: 6 }}>
          {items.map((_, i) => (
            <button key={i} className="gl-btn-bare" onClick={() => setIdx(i)}
              aria-label={`Resource ${i + 1}`}
              style={{
                width: 5, height: 5, borderRadius: '50%',
                background: i === idx ? tokens.accent : tokens.textDim,
                transition: `all 200ms ${tokens.ease}`,
              }} />
          ))}
        </div>
        <button className="gl-btn-bare" onClick={() => setIdx((idx + 1) % items.length)}
          style={{ color: tokens.textMid, fontFamily: tokens.fontBody, fontSize: 12, padding: '4px 10px' }}>Next &#8594;</button>
      </div>
    </section>
  );
}
